import { module } from 'angular'
import { SaleTrackerService } from './sale-tracker.service'

module('webregister.components').service('saleTracker', SaleTrackerService)
